/*
 * @Author: 秦少卫
 * @Date: 2024-06-09 13:02:18
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-05-19 12:02:38
 * @Description: 管理面板管理
 */

import {
  updataTempl,
  uploadImg,
  deleteImg,
  getTempl,
  setToken,
  getAdminInfo,
  adminLogin,
  createdTempl,
  publishTemplApi,
} from '@/api/admin';
import { Spin, Message } from 'view-ui-plus';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { createFormData } from '@/utils';
import usePsd from '@/hooks/usePsd';

export default function useMaterial() {
  const canvasEditor = inject('canvasEditor');
  const router = useRouter();
  const { t } = useI18n();
  const { getUrl } = usePsd();

  const uploadFileToInfo = async () => {
    const base64 = await canvasEditor.preview(0.4);
    // 使用新的公共方法创建 formData
    const formData = createFormData(base64, '123.png');

    // 上传图片
    try {
      const res = await uploadImg(formData);
      const [info] = res.data;
      return info.id;
    } catch (err) {
      console.log(err);
    }
  };

  // 更新详情
  const updataTemplHander = async (id, newName, newType) => {
    Spin.show();
    try {
      const { data: info } = await getTempl(id);
      const newImgId = await uploadFileToInfo();
      const json = canvasEditor.getJson();
      const newJson = await getUrl(json);
      canvasEditor.loadJSON(JSON.stringify(newJson));
      await updataTempl(info.id, {
        ...info,
        name: newName,
        img: newImgId,
        json: newJson,
        templ_type: { disconnect: [], connect: [{ id: newType.value }] },
      });
      deleteImg(info.img.id);
    } catch (error) {
      console.log(error);
      Message.error(t('admin.errorTip'));
    }

    Spin.hide();
  };

  const createdTemplHander = async (name, typeId) => {
    Spin.show();
    try {
      const newImgId = await uploadFileToInfo();
      const json = canvasEditor.getJson();
      const newJson = await getUrl(json);
      canvasEditor.loadJSON(JSON.stringify(newJson));
      const res = await createdTempl({
        name,
        img: newImgId,
        json: newJson,
        templ_type: { disconnect: [], connect: [{ id: typeId.value }] },
      });
      router.replace('/?tempId=' + res.data.id + '&admin=true');
      await publishTemplApi(res.data.id);
    } catch (error) {
      console.log(error);
      Message.error(t('admin.errorTip'));
    }

    Spin.hide();
  };

  const hasLogin = ref(false);
  const userInfo = ref({});
  const getAdminInfoHander = async () => {
    try {
      const res = await getAdminInfo();
      userInfo.value = res.data.data;
      hasLogin.value = true;
    } catch (error) {
      hasLogin.value = false;
    }
  };

  const login = async (formInline) => {
    try {
      const res = await adminLogin(formInline);
      setToken(String(res.data.data.token));
      Message.success(t('login.welcome'));
      return res;
    } catch (error) {
      Message.error('账号认证错误');
    }
  };

  const uploadImgFile = async (file) => {
    console.log(file);

    // 上传图片
    try {
      const res = await uploadImg();
      const [info] = res.data;
      return info.id;
    } catch (err) {
      console.log(err);
    }
  };

  return {
    hasLogin,
    userInfo,
    login,
    getAdminInfoHander,
    updataTemplHander,
    createdTemplHander,
    uploadImgFile,
  };
}
